import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Link, Typography, Divider, Grid } from "@mui/material";
import queryString from "query-string";

export function OptInBookingConfirmation(props) {
  
    //Get clinic name
    const value = queryString.parse(window.location.search);
    const clinician = value.clinician;

  return (
    <Grid container align="center" alignItems="center" justifyContent="center" direction="column">
      <Alert
        severity="success"
        variant="filled"
        sx={{
          mt: {
            xs: 3,
            sm: 2,
          },
          mb: 2,
          maxWidth: "md"
        }}
      >
        <AlertTitle>You have successfully requested a new appointment with <strong>{clinician}</strong></AlertTitle>
        <br />
        <Typography>
          {" "}
          Please note, we are experiencing a high demand for our services, and we will contact you with an offer for the earliest available appointment.
        </Typography>
        <br />
        <br />
        <Divider/>
        <br />
        <Typography>
          {" "}
          If you need to, you can get in touch with us through our website -{" "}
          <Link
            href="https://www.connecthealth.co.uk/contact/"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="always"
          >
            https://www.connecthealth.co.uk/contact/
          </Link>
        </Typography>
        <Typography>
          You will also find information about your service, including opening
          times, services offered and who your clinicians are, on our website.
        </Typography>
        <br />
      </Alert>
    </Grid>
  );
}
